
/*=======================================================================================
NOTE: Auto Generated File
=========================================================================================
Date:       2021-06-18 17:11:13.693
From:       BADGER\SQL2016 - qmuzik_metabase
Comment:    Any manual changes to this file will be overwritten. Move it to the relevant 
			"Custom" directory of the Angular project should you need to maintain your
			own version.
=========================================================================================*/

import { Injectable } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map, tap, debounceTime, switchMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { EISTaskSecurity } from 'qmuzik-angular-model';
import { DataContext, ViewState } from 'qmuzik-angular-model-core';
import { AppGlobal } from 'qmuzik-angular-model-core';
import { ModelBase } from 'qmuzik-angular-model-core';
import { ColumnValues } from 'qmuzik-angular-model-core';
import { DataService } from 'qmuzik-angular-model-core';

import { BaseService } from 'qmuzik-angular-service';
import { LoginService } from 'qmuzik-angular-service';
import { DataContextService } from 'qmuzik-angular-service';

import { Instance, InstanceActions } from 'qmuzik-angular-model-core';


import { Profile } from 'qmuzik-angular-model';
import { EISTasks } from 'qmuzik-angular-model';

@Injectable()
export class EISTaskSecurityService extends BaseService implements DataService {

	protected defaultEISTaskSecurity: EISTaskSecurity[] = [];
	protected servicesInjected: boolean = false;
	protected isComposition: boolean = false;

	constructor(
			protected http: HttpClient,
			protected appGlobal: AppGlobal,
			protected loginService: LoginService,
			protected dataContextService: DataContextService){ 
		super();

		//retrieve defaults used for creation of new model instance
		this.GetDefaults();
	}

	//#region injection

	InjectServices(){

		this.servicesInjected = true; 
	}
	
	//#endregion injection

	//#region crud

	CreateNew(defaultValue: any): EISTaskSecurity{
		//note: default values must be obtained for each company from the rest api
		let source: EISTaskSecurity;
		let target: EISTaskSecurity = new EISTaskSecurity();

		Object.assign(target, defaultValue);

		//note: we want to default certain properties such as dates to a variable value
		//		e.g. we cannot add it as a default
		//		only other option would be to implement a Rule
		this.FormatOnNew(target)

		return target;
	}	

	CreateNewSameAs(source:EISTaskSecurity): EISTaskSecurity {
		let target: EISTaskSecurity = new EISTaskSecurity();

		let primaryProperties = Reflect.getMetadata("PrimaryKeyProperties", source);
		//first copy all the values from the old instance
		Object.keys(source).forEach((key) =>{
			target[key] = source[key];
		});
		//now remove all primary key values
		Object.keys(primaryProperties).forEach((pkey) =>{
			target[pkey] = null;
		});
		return target;
	}

	Delete(modelState: EISTaskSecurity, instance: Instance){
		let uri: string;
		//here we know the CompanyID
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID == modelState.CompanyID){
			uri = this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary";
			break;
			}        
		}          

		let httpParams = new HttpParams();
		httpParams = httpParams.append("TaskName", modelState.TaskName);
		httpParams = httpParams.append("Profile", modelState.Profile);


		let headers = new HttpHeaders({
			"CompanyID": modelState.CompanyID,
			"InstanceInformation": [modelState.FormInstanceId.toString(), modelState.FormSymbolInstanceId.toString(), '0', modelState.FormFormControlName.toString(), instance.instanceMode.toString(), modelState.FormInputId.toString()]
		});

		return this.http.delete(
			uri,
			{
				params: httpParams,
				headers: headers
			}
		)
		.pipe(
			catchError(this.handleError)
		); 
	}

	//note: new or existing are saved here
	Save(modelState: EISTaskSecurity, isNew: boolean, instance: Instance){
		let uri: string;

		let modelStateSave: EISTaskSecurity = Object.assign(new EISTaskSecurity(), modelState);

		//note: there really is no choice here, we have to run through all properties and convert editable date to correct format
		modelStateSave = this.FormatBeforeSave(modelStateSave, isNew);
		modelStateSave["PropertyStoreType"] = null;
		modelStateSave["HeaderControl"] = null;

		//here we know the CompanyID
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID == modelState.CompanyID){
				uri = this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary";
				break;
			}        
		}   

		let headers = new HttpHeaders({
			"CompanyID": modelState.CompanyID,
			"InstanceInformation": [modelState.FormInstanceId.toString(), modelState.FormSymbolInstanceId.toString(), '0', modelState.FormFormControlName.toString(), instance.instanceMode.toString(), modelState.FormInputId.toString()]
		});

		if(isNew){
			return this.http.post(
			this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary/PostEISTaskSecurity",
				modelStateSave,
				{
					headers: headers
				}
			)
			.pipe(
			catchError(this.handleError)
			); 
		}
		else{
			let httpParams = new HttpParams();
			httpParams = httpParams.append("TaskName", modelState.TaskName);
		httpParams = httpParams.append("Profile", modelState.Profile);
 

			return this.http.put(
			this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary",       
				modelStateSave,
				{
					params: httpParams,
					headers: headers
				}
			)
			.pipe(
			catchError(this.handleError)
			); 
		}
	}

	//#endregion crud
  
	//#region create for

	//note: we need an instance to build our form initially
	CreateForInitialisation(): EISTaskSecurity{
		let eISTaskSecurity: EISTaskSecurity = new EISTaskSecurity();
		eISTaskSecurity.CompanyID = this.loginService.defaultCompanyID;
		return eISTaskSecurity;
	}
	//note: initialise all properties of model instance to null
	CreateForFilter(): EISTaskSecurity{
		let eISTaskSecurity: EISTaskSecurity = new EISTaskSecurity();
		Object.keys(eISTaskSecurity).forEach((key) =>{
			eISTaskSecurity[key] = null;
		});
		eISTaskSecurity.CompanyID = this.loginService.defaultCompanyID;
		return eISTaskSecurity;
	}

	CreateForFilterRefProfile(): Profile{
		let profile: Profile = new Profile();
		Object.keys(profile).forEach((key) =>{
			profile[key] = null;
		});
		profile.CompanyID = this.loginService.defaultCompanyID;
		return profile;
	}
	CreateForFilterRefEISTasks(): EISTasks{
		let eISTasks: EISTasks = new EISTasks();
		Object.keys(eISTasks).forEach((key) =>{
			eISTasks[key] = null;
		});
		eISTasks.CompanyID = this.loginService.defaultCompanyID;
		return eISTasks;
	}

	//#endregion create for

	//#region assign to type

	//note: selecting an object in the typeahead we need to "cast" it to the required type so that instanceof works
	AssignToType(item): EISTaskSecurity{
		//must use assign here, otherwise instancof checks will not work
		return Object.assign(new EISTaskSecurity(), item as EISTaskSecurity)
	}

	//note: assign all foreign key properties to it's actual type so that instanceof works
	AssignToTypeForeignKey(item, foreignKeyProperty: string): any{
		if(!this.servicesInjected){
			this.InjectServices();
		}

		if(foreignKeyProperty == 'RefProfile'){
			//must use assign here, otherwise instancof checks will not work
			//return this.profileService.AssignToType(item);
			return Object.assign(new Profile(), item as Profile);		
		}
		if(foreignKeyProperty == 'RefEISTasks'){
			//must use assign here, otherwise instancof checks will not work
			//return this.eISTasksService.AssignToType(item);
			return Object.assign(new EISTasks(), item as EISTasks);		
		}
		if(foreignKeyProperty == 'Ref_CompanyID'){
			//must use assign here, otherwise instancof checks will not work
			return this.dataContextService.AssignToType(item);
		} 
	}  

	/**
	 * Check if an object is of type EISTaskSecurity
	 * @param item 
	 */
	IsType(item): boolean {
		if(item instanceof EISTaskSecurity){
			return true;
		}

		return false;
	}

	//#endregion assign to type

	//#region header control search 
  
	formatter = (result: EISTaskSecurity) => (this.GetFormatter(result));   
	inputFormatter = (result: EISTaskSecurity) => (result.TaskName + " " + result.Profile); 

	//note: if multi-company we must display the id so a user can "know"
	GetFormatter(result: EISTaskSecurity): any{

		if(this.loginService.defaultCompanyID === ""){
			for(var i = 0; i < this.loginService.dataContext.length; i++){
				if(result.CompanyID === this.loginService.dataContext[i].CompanyID){
					return result.TaskName + " | " + result.Profile + "   |   " + this.loginService.dataContext[i].Description;
				}
			}
		}
		else{
			return result.TaskName + " | " + result.Profile;
		}
	}

	//#endregion header control search 

	//#region instance related

	//note: delete all objects saved to the instance entity
	DeleteInstanceObjects(instance: Instance, companyID: string){
		let uri: string;
		//here we know the CompanyID
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID == companyID){
			uri = this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary/DeleteEISTaskSecurityInstanceObjects";
			break;
			}        
		}          

		let headers = new HttpHeaders({
			"CompanyID": companyID,
			"InstanceInformation": [instance.instanceId.toString(), instance.symbolInstanceId.toString(), '0', instance.formControlName.toString(), instance.instanceMode.toString(), '0']
		});

		return this.http.delete(
			uri,
			{
				headers: headers
			}
		)
		.pipe(
			catchError(this.handleError)
		); 
	}

	//note: handle all instance actions
	DoInstanceActions(
			modelState: EISTaskSecurity, 
			isNew: boolean, 
			instanceInformation: Instance,
			isList: boolean)
	{
		let uri: string;
		let modelStateSave: EISTaskSecurity = Object.assign(new EISTaskSecurity(), modelState);

		//note: there really is no choice here, we have to run through all properties and convert editable date to correct format
		//#region formatting
		modelStateSave = this.FormatBeforeSave(modelStateSave, isNew);
		modelStateSave["PropertyStoreType"] = null;
		modelStateSave["HeaderControl"] = null;
		//#endregion formatting

		let instanceData: any = {};
		instanceData.chosenSymbolInstanceActivityId = instanceInformation.chosenSymbolInstanceActivityId;
		instanceData.instanceAction = instanceInformation.instanceAction;
		instanceData.modelState = modelStateSave;
		instanceData.isNew = isNew;
		instanceData.isList = isList;

		//here we know the CompanyID
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID == modelState.CompanyID){
				uri = this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary";
				break;
			}        
		}   

		let headers = new HttpHeaders({
			"CompanyID": modelState.CompanyID,
			"InstanceInformation": [instanceInformation.instanceId.toString(), instanceInformation.symbolInstanceId.toString(), '0', instanceInformation.formControlName.toString(), instanceInformation.instanceMode.toString(), modelState.FormInputId.toString()]
		});

		return this.http.post(
		this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary/PostEISTaskSecurityDoInstanceActions",
			instanceData,
			{
				headers: headers
			}
		)
		.pipe(
		catchError(this.handleError)
		); 
	
	}

	//note: retrieve the count of objects saved for this symbol instance
	//		required for behaviour of view when working with instance
	GetSymbolInstanceSavedObjectCount(instanceInformation: Instance, companyIDPassed: string){
		let uri: string;

		//here we know the CompanyID
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID == companyIDPassed){
				uri = this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary/GetEISTaskSecuritySymbolInstanceCount";
				break;
			}        
		}   

		let headers = new HttpHeaders(
			{
				"CompanyID": companyIDPassed,
				"InstanceInformation": [instanceInformation.instanceId.toString(), instanceInformation.symbolInstanceId.toString(), '0', instanceInformation.formControlName.toString(), instanceInformation.instanceMode.toString(), instanceInformation.inputId.toString()]
			}
		);			

		return this.http.get<number>(
			uri,
			{
				headers: headers
			}
		)
		.pipe(
			catchError(this.handleError)
		); 	
	}

	AddToInstance(modelState: EISTaskSecurity){
		let uri: string;

		let modelStateSave: EISTaskSecurity = Object.assign(new EISTaskSecurity(), modelState);

		//note: there really is no choice here, we have to run through all properties and convert editable date to correct format
		modelStateSave = this.FormatBeforeSave(modelStateSave, false);
		modelStateSave["PropertyStoreType"] = null;
		modelStateSave["HeaderControl"] = null;

		//here we know the CompanyID
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID == modelState.CompanyID){
				uri = this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary";
				break;
			}        
		}   

		let headers = new HttpHeaders({
			"CompanyID": modelState.CompanyID,
			"InstanceInformation": [modelState.FormInstanceId.toString(), modelState.FormSymbolInstanceId.toString(), '0', modelState.FormFormControlName.toString(), 'false', modelState.FormInputId.toString()]
		});

		return this.http.post(
		this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary/PostEISTaskSecurityToInstance",
			modelStateSave,
			{
				headers: headers
			}
		)
		.pipe(
		catchError(this.handleError)
		); 
	
	}

	//#endregion instance related

	//#region defaults

	//note: for all companies, retrieve the default values for a new model instance
	GetDefaults(){
		//note: compositions has no concept of defaults
		//		this may change in future
		if(this.isComposition){
			return;
		}

		//run through data contexts and get the defaults for a company
		let observables: Observable<any>[] = [];
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID === ""){
				continue;
			}

			let headers = new HttpHeaders({
				"CompanyID": this.loginService.dataContext[i].CompanyID
			});

			let observable = this.http.get(
			this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary/GetEISTaskSecurityDefault",
				{
					headers: headers
				}
			)
			.pipe(
			catchError(this.handleError)
			); 

			observables.push(observable);
		};
    
		forkJoin(observables).pipe(map((data: any[]) => {
			return this.FormatObserveablesArray(data);
		})).subscribe((result: EISTaskSecurity[])=>{
			this.defaultEISTaskSecurity = result;
			this.defaults = result;
			//note: let the component base know defaults have been retrieved
			this.defaultsSubscription.next();	
		});  
	}

	//note: defaults can be defined for a symbol template if view is displayed as part of an instance
	//		this will always be retrieved for a known company
	GetDefaultsInstance(instanceId: number, symbolInstanceId: number, CompanyIDPassed: string){
		let uri: string;

		//here we know the CompanyID
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID == CompanyIDPassed){
				uri = this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary/GetEISTaskSecurityDefault";
				break;
			}        
		}   

		let headers = new HttpHeaders(
			{
				"CompanyID": CompanyIDPassed,
				"InstanceInformation": [instanceId.toString(),symbolInstanceId.toString(), '0', '', 'false', '0']
			}
		);			

		return this.http.get<EISTaskSecurity[]>(
			uri,
			{
				headers: headers
			}
		)
		.pipe(
			catchError(this.handleError)
		); 		
	}

	//#endregion defaults	

	//#region auto select

	/**
	 * Calls service to check if there is only one record available
	 * 
	 * If so, the webservice will return the record so it can be auto selected
	 */
	GetAutoSelect(instance: Instance, modelState: EISTaskSecurity, serializationLevel?: number){
		this.Search([], [], [], instance, modelState, serializationLevel, null, true).subscribe(
			(results: EISTaskSecurity[])=>{
				if(results.length == 1){
					this.autoSelectSubscription.next(results[0]);
				}
				else{
					this.autoSelectSubscription.next(null);
				}
			}
		)
	}

	//#endregion auto select

	//#region get entity data

	//note: return a single object by primary key
	GetByPrimaryKey(TaskName: string, Profile: string, CompanyIDPassed: string, serializationLevel?: number){
		let uri: string;

		if((serializationLevel === undefined) || (serializationLevel === null)){
			serializationLevel = 0;
		}

		//here we know the CompanyID
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID == CompanyIDPassed){
				uri = this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary";
				break;
			}        
		}    
    
		let httpParams = new HttpParams();
		httpParams = httpParams.append("TaskName", TaskName);
		httpParams = httpParams.append("Profile", Profile);
    

		let headers = new HttpHeaders({
			"CompanyID": CompanyIDPassed,
			"SerializationLevel":  serializationLevel.toString()
		});			

		return this.http.get<EISTaskSecurity[]>(
			uri,
			{
				params: httpParams,
				headers: headers
			}
		)
		.pipe(
			catchError(this.handleError)
		); 
	}

	Search(filter: any[], advancedFilter: ModelBase[], staticFilter: ModelBase[], instance: Instance, modelState: EISTaskSecurity, serializationLevel?: number, viewName?: string, autoSelectCheck?:boolean, viewState?: ViewState){
		if(this.isComposition){
			return new Observable(null);
		}		
		
		//get the operator array
		//always use "like" for the standard filter
		let operatorArray: any[];

		//so, remember why we do it this way:
		//we need to send the model state to the rest service
		//reason: depending on the model state it may filter itself differently
		//that is not something I can "generate", it depends on business rules
		let searchCriteria: any = {};

		if(autoSelectCheck){
			searchCriteria.autoSelectCheck = autoSelectCheck;
		}
    
		searchCriteria.filter = filter;

		if((serializationLevel === undefined) || (serializationLevel === null)){
			serializationLevel = 0;
		}

		//add any advanced filters to the array
		if((advancedFilter !== undefined) && (advancedFilter !== null)){
			if(advancedFilter.length != 0){
				searchCriteria.filter = [];
			}

			for(var j = 0; j < advancedFilter.length; j++){
				advancedFilter[j]["HeaderControl"] = null;
				advancedFilter[j]["Ref_CompanyID"] = null;
				searchCriteria.filter.push(advancedFilter[j]);
			}

			operatorArray = this.GetOperatorArray(null, advancedFilter)
		}
		else{
			operatorArray = this.GetOperatorArray(filter, null)
		}

		searchCriteria.operators = operatorArray;
		searchCriteria.staticFilter = staticFilter;
  
		let observables: Observable<any>[] = [];

		if(this.loginService.defaultCompanyID === ""){
			let dataContexts: DataContext[] = this.loginService.GetValidDataContexts(viewName);
			for(var i = 0;i < dataContexts.length; i++){
				if(this.loginService.dataContext[i].CompanyID === ""){
					continue;
				}

				let headers = new HttpHeaders({
					"CompanyID": this.loginService.dataContext[i].CompanyID,
					"InstanceInformation": [instance.instanceId.toString(), instance.symbolInstanceId.toString(), '0', instance.formControlName, instance.instanceMode.toString(), '0'],
					"SerializationLevel": serializationLevel.toString()
				  });

				let observable = this.http.post(
					this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary/PostEISTaskSecurity_HeaderControl",
					searchCriteria,
					{
						headers: headers,
						observe: 'response'
					}
				)
				.pipe(
					map(result=>{	
						if(viewState){	
							viewState[result.headers.get("CompanyID")]["HeaderControl"]["TotalResultCount"] = parseInt(result.headers.get("TotalResultCount"));	
						}										
						return result.body;
					}),
					catchError(this.handleError)
				); 
		
				observables.push(observable);
			}
		}
		else{
			let headers: HttpHeaders;
			let numberOfRows: number = this.GetNumberOfRows("HeaderControl", modelState);
			if(numberOfRows === null){
				headers = new HttpHeaders({
					"CompanyID": this.loginService.selectedDataContext.CompanyID,
					"InstanceInformation": [instance.instanceId.toString(), instance.symbolInstanceId.toString(), '0', instance.formControlName, instance.instanceMode.toString(), '0'],
					"SerializationLevel": serializationLevel.toString()
				});				
			}
			else{
				headers = new HttpHeaders({
					"CompanyID": this.loginService.selectedDataContext.CompanyID,
					"InstanceInformation": [instance.instanceId.toString(), instance.symbolInstanceId.toString(), '0', instance.formControlName, instance.instanceMode.toString(), '0'],
					"ResultCount": [numberOfRows.toString()],
					"SerializationLevel": serializationLevel.toString()
				});	
			}

			let observable = this.http.post(
				this.loginService.selectedDataContext.ServiceUri + "api/EISTaskSecurityLibrary/PostEISTaskSecurity_HeaderControl",
				searchCriteria,
				{
					headers: headers,
					observe: 'response'
				}
			)
			.pipe(
				map(result=>{
					if(viewState){	
						viewState[result.headers.get("CompanyID")]["HeaderControl"]["TotalResultCount"] = parseInt(result.headers.get("TotalResultCount"));	
					}					
					return result.body;
				}),
				catchError(this.handleError)
			); 
	
			observables.push(observable);
		}
      
		return forkJoin(observables).pipe(map((data: any[]) => {
			return this.FormatObserveablesArray(data);
		}));
	}

	//note: return all without filtering
	GetEISTaskSecurity(){
		//here is now where the shite his the fan
		//we must merge multiple observables into one result set
		//e.g. loop through all our logged in user's data contexts
		//create an observable for each of those contexts
		//merge the result
		let observables: Observable<any>[] = [];
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID === ""){
				continue;
			}

			let headers = new HttpHeaders({
				"CompanyID": this.loginService.dataContext[i].CompanyID
			});

			let observable = this.http.get(
			this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary",
				{
					headers: headers
				}
			)
			.pipe(
			catchError(this.handleError)
			); 

			observables.push(observable);
		}
    
		return forkJoin(observables).pipe(map((data: any[]) => {
			return this.FormatObserveablesArray(data);
		}));
	}

	//#endregion get entity data

	//#region get foreign key values

	//all typeaheads used to find an entity value
	//in the database will generate their own method
	//the object model state will be sent to the api
	//since the data may be required to filter in some
	//custom way


	Get_EISTaskSecurity_RefProfile(filter: any[], advancedFilter: ModelBase[], modelState: EISTaskSecurity, viewState: ViewState){
		//get the operator array
		//always use "like" for the standard filter
		let operatorArray: any[];

		//so, remember why we do it this way:
		//we need to send the model state to the rest service
		//reason: depending on the model state it may filter itself differently
		//that is not something I can "generate", it depends on business rules
		let searchCriteria: any = {};
    
		searchCriteria.filter = filter;

		//add any advanced filters to the array
		if((advancedFilter !== undefined) && (advancedFilter !== null)){
			if(advancedFilter.length != 0){
				searchCriteria.filter = [];
			}

			for(var j = 0; j < advancedFilter.length; j++){
				advancedFilter[j]["HeaderControl"] = null;
				advancedFilter[j]["Ref_CompanyID"] = null;
				searchCriteria.filter.push(advancedFilter[j]);
			}

			operatorArray = this.GetOperatorArray(null, advancedFilter)
		}
		else{
			operatorArray = this.GetOperatorArray(filter, null)
		}

		searchCriteria.operators = operatorArray;

		//note: we may have to transfer the decorator overrides here at some point
		searchCriteria.modelState =  new EISTaskSecurity();
		Object.assign(searchCriteria.modelState, modelState);	  
		searchCriteria.modelState = this.FormatBeforeSave(searchCriteria.modelState, false);


		searchCriteria.operators = operatorArray;

		//note: if the modelstate has a company id we should only use that
		//only search on all if the company id is null or spaces
		let observables: Observable<any>[] = [];

		searchCriteria.modelState.CompanyID = modelState.CompanyID;
		searchCriteria.modelState.HeaderControl = null;

		let headers: HttpHeaders;
		let numberOfRows: number = this.GetNumberOfRows("RefProfile", modelState);
		if(numberOfRows === null){
			headers = new HttpHeaders({
				"CompanyID": modelState.CompanyID,
			});
		}
		else{
			headers = new HttpHeaders({
				"CompanyID": modelState.CompanyID,
				"ResultCount": [numberOfRows.toString()]
			});
		}


		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID === modelState.CompanyID){
				break;
			}
		}

		let observable = this.http.post(
			this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary/PostProfile_RefProfile",
				searchCriteria,
				{
					headers: headers,
					observe: 'response'
				}
		)
		.pipe(
			map(result=>{
				if(viewState){	
					if(result.headers.get("TotalResultCount")){
						viewState[result.headers.get("CompanyID")]["RefProfile"]["TotalResultCount"] = parseInt(result.headers.get("TotalResultCount"));
					}	
				}					
				return result.body;
			}),
			catchError(this.handleError)
		); 

		observables.push(observable);
		
    
		return forkJoin(observables).pipe(map((data: any[]) => {
			return this.FormatObserveablesArray(data);
		}));
	}


	//generated: return a single object by primary key for foreign key
	//note: this is here because we need to avoid references to the other data services 
	GetByPrimaryKeyProfile(ProfileProperty: string,  CompanyIDPassed: string){
		let uri: string;

		//here we know the CompanyID
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID == CompanyIDPassed){
				uri = this.loginService.dataContext[i].ServiceUri + "api/ProfileLibrary";
				break;
			}        
		}    
    
		let httpParams = new HttpParams();
		httpParams = httpParams.append("ProfileProperty", ProfileProperty);

    

		let headers = new HttpHeaders({
			"CompanyID": CompanyIDPassed
		});			

		return this.http.get<Profile[]>(
			uri,
			{
				params: httpParams,
				headers: headers
			}
		)
		.pipe(
			catchError(this.handleError)
		); 
	}


	Get_EISTaskSecurity_RefEISTasks(filter: any[], advancedFilter: ModelBase[], modelState: EISTaskSecurity, viewState: ViewState){
		//get the operator array
		//always use "like" for the standard filter
		let operatorArray: any[];

		//so, remember why we do it this way:
		//we need to send the model state to the rest service
		//reason: depending on the model state it may filter itself differently
		//that is not something I can "generate", it depends on business rules
		let searchCriteria: any = {};
    
		searchCriteria.filter = filter;

		//add any advanced filters to the array
		if((advancedFilter !== undefined) && (advancedFilter !== null)){
			if(advancedFilter.length != 0){
				searchCriteria.filter = [];
			}

			for(var j = 0; j < advancedFilter.length; j++){
				advancedFilter[j]["HeaderControl"] = null;
				advancedFilter[j]["Ref_CompanyID"] = null;
				searchCriteria.filter.push(advancedFilter[j]);
			}

			operatorArray = this.GetOperatorArray(null, advancedFilter)
		}
		else{
			operatorArray = this.GetOperatorArray(filter, null)
		}

		searchCriteria.operators = operatorArray;

		//note: we may have to transfer the decorator overrides here at some point
		searchCriteria.modelState =  new EISTaskSecurity();
		Object.assign(searchCriteria.modelState, modelState);	  
		searchCriteria.modelState = this.FormatBeforeSave(searchCriteria.modelState, false);


		searchCriteria.operators = operatorArray;

		//note: if the modelstate has a company id we should only use that
		//only search on all if the company id is null or spaces
		let observables: Observable<any>[] = [];

		searchCriteria.modelState.CompanyID = modelState.CompanyID;
		searchCriteria.modelState.HeaderControl = null;

		let headers: HttpHeaders;
		let numberOfRows: number = this.GetNumberOfRows("RefEISTasks", modelState);
		if(numberOfRows === null){
			headers = new HttpHeaders({
				"CompanyID": modelState.CompanyID,
			});
		}
		else{
			headers = new HttpHeaders({
				"CompanyID": modelState.CompanyID,
				"ResultCount": [numberOfRows.toString()]
			});
		}


		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID === modelState.CompanyID){
				break;
			}
		}

		let observable = this.http.post(
			this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary/PostEISTasks_RefEISTasks",
				searchCriteria,
				{
					headers: headers,
					observe: 'response'
				}
		)
		.pipe(
			map(result=>{
				if(viewState){	
					if(result.headers.get("TotalResultCount")){
						viewState[result.headers.get("CompanyID")]["RefEISTasks"]["TotalResultCount"] = parseInt(result.headers.get("TotalResultCount"));
					}	
				}					
				return result.body;
			}),
			catchError(this.handleError)
		); 

		observables.push(observable);
		
    
		return forkJoin(observables).pipe(map((data: any[]) => {
			return this.FormatObserveablesArray(data);
		}));
	}


	//generated: return a single object by primary key for foreign key
	//note: this is here because we need to avoid references to the other data services 
	GetByPrimaryKeyEISTasks(TaskName: string,  CompanyIDPassed: string){
		let uri: string;

		//here we know the CompanyID
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID == CompanyIDPassed){
				uri = this.loginService.dataContext[i].ServiceUri + "api/EISTasksLibrary";
				break;
			}        
		}    
    
		let httpParams = new HttpParams();
		httpParams = httpParams.append("TaskName", TaskName);

    

		let headers = new HttpHeaders({
			"CompanyID": CompanyIDPassed
		});			

		return this.http.get<EISTasks[]>(
			uri,
			{
				params: httpParams,
				headers: headers
			}
		)
		.pipe(
			catchError(this.handleError)
		); 
	}


	//note: special case
	//		after a selection occurs we want to do one call to retrieve the
	//		foreign key objects. this can be done with the serialisaction level set to > 1
	GetPrimaryKeyObject(values: any[], companyID: string, serializationLevel: number): Observable<any>{
		return this.GetByPrimaryKey(values[0], values[1],  companyID, serializationLevel);
	}

	//note: each foreign key must be loadable from here
	GetForeignKeyObject(foreignKey: string, values: string[], companyID: string): Observable<any>{

		if(!this.servicesInjected){
			this.InjectServices();
		}


		if(foreignKey === "RefProfile"){
			//in qmuzik foreign keys are represented by spaces
			if((values[0].toString().replace(/ /g, "")) === "" ||  (values[0] === null))
			{
				return new Observable(null);
			}

			//return this.profileService.GetByPrimaryKey(values[0], companyID);
			return this.GetByPrimaryKeyProfile(values[0], companyID);

		}  
		if(foreignKey === "RefEISTasks"){
			//in qmuzik foreign keys are represented by spaces
			if((values[0].toString().replace(/ /g, "")) === "" ||  (values[0] === null))
			{
				return new Observable(null);
			}

			//return this.eISTasksService.GetByPrimaryKey(values[0], companyID);
			return this.GetByPrimaryKeyEISTasks(values[0], companyID);

		}  

		if(foreignKey === "Ref_CompanyID"){
			//in qmuzik foreign keys are represented by spaces
			if((values[0].replace(/ /g, "")) === "" || (values[0] === null))
			{
				return new Observable(null);
			}

			for(var i = 0; i < this.loginService.dataContext.length; i++){
				if(this.loginService.dataContext[i].CompanyID === values[0]){
					return of(this.loginService.dataContext[i]);
				}
			}
		}           
	}

	//composite view: a foreign key value has been selected
	//we must now filter on this foreign key
	FilterByForeignKey(filterOnProperties: string[], filterFromProperties: string[], modelState: ModelBase){
		return new Observable(null);
	}

	//#endregion get foreign key values

	//#region column values

	//note: return a single object by primary key for ColumnValues
	GetByPrimaryKeyColumnValues(ColumnName: string, ColumnValue: string, CompanyID: string){
		let uri: string;
		//here we know the CompanyID
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID == CompanyID){
			uri = this.loginService.dataContext[i].ServiceUri + "api/Column_ValuesLibrary";
			break;
			}        
		}    
		
		let httpParams = new HttpParams();
		httpParams = httpParams.append("ColumnName", ColumnName);
		httpParams = httpParams.append("ColumnValue", ColumnValue);
		
	
		let headers = new HttpHeaders({
			"CompanyID": CompanyID
		});			
	
	
		return this.http.get<ColumnValues[]>(
			uri,
			{
				params: httpParams,
				headers: headers
			}
		)
		.pipe(
			catchError(this.handleError)
		); 
	}

	//#endregion column values

	//#region general

	//note: call to rest api to asynchronously validate a property
	AsyncValidation(property: string, modelState: EISTaskSecurity, isNew: boolean){
		let modelStateAsync: EISTaskSecurity = Object.assign(new EISTaskSecurity(), modelState);

		modelStateAsync["PropertyStoreType"] = null;
		modelStateAsync["HeaderControl"] = null;
		modelStateAsync = this.FormatBeforeSend(modelStateAsync);

		let validationCriteria: any = {};
		validationCriteria.property = property;
		validationCriteria.modelState = modelStateAsync;
		validationCriteria.isNew = isNew;

		let uri: string;
		//here we know the CompanyID
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID == modelState.CompanyID){
				uri = this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary/PostAsyncValidate";
				break;
			}        
		}          

		let headers = new HttpHeaders({
			"CompanyID": modelState.CompanyID
		});

		return this.http.post(
			uri,
			validationCriteria,
			{
				headers: headers
			}
		)
		.pipe(
			catchError(this.handleError)
		); 
	}

	SaveToDefaults(modelState: EISTaskSecurity, isNew: boolean, name: string){
		let uri: string;
		let modelStateSave: EISTaskSecurity = Object.assign(new EISTaskSecurity(), modelState);
		let primaryProperties = Reflect.getMetadata("PrimaryKeyProperties", modelStateSave);
		//make sure no primary key values are saved ? not sure if necessary
		primaryProperties.forEach((pkey:string) =>{
		//	modelStateSave[pkey] = null;
		});
		//note: there really is no choice here, we have to run through all properties and convert editable date to correct format
		modelStateSave = this.FormatBeforeSave(modelStateSave, isNew);

		modelStateSave["PropertyStoreType"] = null;
		modelStateSave["HeaderControl"] = null;
		
		//here we know the CompanyID
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID == modelState.CompanyID){
				uri = this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityLibrary/PostEISTaskSecurityDefault";
				break;
			}        
		}   

		let headers = new HttpHeaders({
			"CompanyID": modelState.CompanyID
		});
		//set extended properties of default object
		//need to think about profile/company defaults
		//Object.assign(new CommodityMaster(), item as commodi)
		modelStateSave["Company_ID_Default"] = modelState.CompanyID;
		modelStateSave["Employee_ID_Default"] = this.loginService.selectedDataContext.EmployeeId;
		modelStateSave["Name_Default"] = name;

		let httpParams = new HttpParams();

		if(isNew){
			return this.http.post(
				uri,
				modelStateSave,
				{
					headers: headers
				}
			)
			.pipe(
			catchError(this.handleError)
			); 
		}
		else{
			let httpParams = new HttpParams(); 
			httpParams = httpParams.append("TaskName", modelState.TaskName);
		httpParams = httpParams.append("Profile", modelState.Profile);

 

			return this.http.put(
				uri,       
				modelStateSave,
				{
					params: httpParams,
					headers: headers
				}
			)
			.pipe(
			catchError(this.handleError)
			);
		}
		
	}

	DeleteDefault(modelState: any, instance: Instance) :Observable<any>{
		let uri: string;
		//here we know the CompanyID
		for(var i = 0;i < this.loginService.dataContext.length; i++){
			if(this.loginService.dataContext[i].CompanyID == modelState.CompanyID){
			uri = this.loginService.dataContext[i].ServiceUri + "api/EISTaskSecurityDefaultLibrary";
			break;
			}        
		}          

		let httpParams = new HttpParams();
		httpParams = httpParams.append("Name_Default", modelState.NameDefault);
		httpParams = httpParams.append("Employee_ID_Default", this.loginService.selectedDataContext.EmployeeId);

		let headers = new HttpHeaders({
			"CompanyID": modelState.CompanyID
		});

		return this.http.delete(
			uri,
			{
				params: httpParams,
				headers: headers
			}
		)
		.pipe(
			catchError(this.handleError)
		); 
	}
	//#endregion general	
}
